
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header/Header.js';
import ProgramDetails from './ProgramDetails/ProgramDetails.js';
import Footer from './Footer/Footer.js';
import Curriculum from './Curriculum/Curriculum.js';
import BookTrail from './BookTrail/BookTrail.js';
import Testimonial from './Testimonial/Testimonial.js';
import FAQ from './FAQ/Faq.js';
import Query from './Query/Query.js';
import Center from './Centers/Center.js';
import ExplorePlan from './ExplorePlan/ExplorePlan.js';
import PlanDetail from './PlanDetails/PlanDetail.js';
import Signup from './Signup/Signup.js';
import GetInTouch from './GetInTouch/GetInTouch.js';
import Glimpse from './Glimpse/Glimpse.js';
import UserTracker from './UserTracker.js';
import { initFacebookPixel } from './facebookPixel.js';
import SuccessPage from './BookTrail/SuccessPage.js';
import Popup from './Popup/Popup.js';
import ThankyouPage from './BookTrail/ThankyouPage.js';
import FloatingWhatsApp from './Signup/FloatingWhatsApp.js';
function App() {
  useEffect(() => {
    initFacebookPixel(); // Initialize Facebook Pixel on app load
  }, []);
  return (
    <Router>
      <div>
        
        <Routes>
          <Route path="/" element={
            <>
             <Header />
             <GetInTouch/>
        <ProgramDetails />
        <Curriculum />
        <Center/>
        {/* <PlanDetail/> */}
        <Testimonial/>
        <ExplorePlan/>

        <FAQ/>
        <Glimpse/>
        <Footer/>
        <Popup/>
        <FloatingWhatsApp/>
        {/* <Signup/> */}
            </>
          } />
          
          {/* <Route path="/book-trial" element={<>
          <BookTrail />
          </>} /> */}
          <Route path="/thankyou-page" element={<>
          <ThankyouPage />
          </>} />
          {/* <Route path="/SuccessPage" element={<>
          <SuccessPage />
          </>} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
